import React from "react";
import Styles from './styles.module.scss';
import {SOCIAL_LINKS} from "../../cabinetShell/config";

import mascot from '../../../theme/assets/redesign/mascot.webp';
import logoFtf from '../../../theme/assets/redesign/logo_ftf.svg';
import {ReactComponent as TelegramIcon} from '../../../theme/assets/redesign/social/telegram.svg';
import {ReactComponent as YoutubeIcon} from '../../../theme/assets/redesign/social/youtube.svg';
import {ReactComponent as XIcon} from '../../../theme/assets/redesign/social/x.svg';
import {ReactComponent as MediumIcon} from '../../../theme/assets/redesign/social/medium.svg';

const ICONS = {telegram: TelegramIcon, youtube: YoutubeIcon, x: XIcon, medium: MediumIcon};


// Блок сообщества: маскот, логотип и ссылки на соцсети проекта
const CommunityPromo = ({compact}) => (
    <div className={`${Styles.container} ${compact ? Styles.compact : ''}`}>
        <img className={Styles.mascot} src={mascot} alt=""/>
        <img className={Styles.logo} src={logoFtf} alt="F#ck The Fomo" width="150" height="27"/>
        <div className={Styles.socials}>
            {SOCIAL_LINKS.map(({key, label, url}) => {
                const Icon = ICONS[key];
                return (
                    <a key={key} className={Styles.social} href={url} target="_blank" rel="noopener noreferrer" aria-label={label} title={label}>
                        <Icon width="18" height="18" aria-hidden="true"/>
                    </a>
                );
            })}
        </div>
    </div>
);

export default CommunityPromo;
